import { Button, Col, Form, Input, Row, Typography } from "antd";
import React, { useContext } from "react";

import { ConfigStateContext } from "../../../shared-components/Contexts/Configurations/context";
import { ImagenOptimizada } from "shared-components/Components/Image/web";
import { InfoCircleFilled } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

export const SectionInfo = () => {
	const { site_name } = useContext(ConfigStateContext);

	return (
		<div className="container-info">
			<InfoCircleFilled className="icon-info" />
			<Paragraph className="description-info">
				Recuerde que <Text strong>{site_name} no es una inmobiliaria</Text>, por lo que no
				respondemos consultas referidas a la venta o alquiler de las propiedades que se
				encuentran en nuestro sitio.
			</Paragraph>
		</div>
	);
};

export const SectionHelp = ({ dataSectionHelp }) => {
	const { site_name } = useContext(ConfigStateContext);

	return (
		<div className="container-help">
			{site_name == "CEEE" && (
				<div className="img-help">
					<ImagenOptimizada
						src={
							"https://cdn2.casaseneleste.com/web/598b765e8cb4b_infocdn__597b38a826a4f_infocdn__lobi-optimizado.png"
						}
						alt={"CEEE"}
					/>
				</div>
			)}
			<Title level={2} className="title-help">
				{"¿En qué podemos ayudarte?"}
			</Title>
			<Row justify="space-between" gutter={[16, 16]}>
				{dataSectionHelp.map(item => (
					<Col key={item.id} span={24} sm={12} lg={5} className="item-help">
						<div className="icon-help">{item.icon}</div>
						<div className="text-help">{item.desc}</div>
					</Col>
				))}
			</Row>
		</div>
	);
};

export const SectionForm = ({ form, validateMessages, validateRules, loading, submitForm }) => {

	return (
		<div className="container-contact">
			<Form
				form={form}
				name="contact-form"
				scrollToFirstError
				validateMessages={validateMessages}>
				<Row gutter={12}>
					<Col xs={24} md={16}>
						<Form.Item name="nombre" hasFeedback rules={validateRules.nombre}>
							<Input className="secondary" placeholder="Nombres y Apellidos *" />
						</Form.Item>
					</Col>
					<Col xs={24} md={8}>
						<Form.Item name="telefono" hasFeedback rules={validateRules.telefono}>
							<Input className="secondary" placeholder="Teléfono *" />
						</Form.Item>
					</Col>
					<Col xs={24}>
						<Form.Item name="email" hasFeedback rules={validateRules.email}>
							<Input className="secondary" placeholder="Correo Electrónico *" />
						</Form.Item>
					</Col>
					<Col xs={24}>
						<Form.Item name="consulta" hasFeedback rules={validateRules.consulta}>
							<Input.TextArea
								placeholder="Consulta *"
								autoSize={{ minRows: 5, maxRows: 5 }}
							/>
						</Form.Item>
					</Col>
					<Col xs={24}>
						<Form.Item className="container-button">
							<Button
								type="primary"
								className="btn-send-lead"
								loading={loading}
								onClick={submitForm}>
								{"Enviar"}
							</Button>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</div>
	);
};

export const SectionFAQs = ({ dataSectionFAQs }) => {

	return (
		<div className="container-FAQs">
			<Row justify="space-between" gutter={[16, 16]}>
				{dataSectionFAQs.map(item => (
					<Col key={item.id} span={24} lg={11} className="item-FAQs">
						<div className="img-FAQs">
							<ImagenOptimizada src={item.img} alt={item.alt} />
						</div>
						<span className="text-FAQs">{item.desc}</span>
					</Col>
				))}
			</Row>
		</div>
	);
};
